// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"CloseButton_closeButton__1_mZr","disabled":"CloseButton_disabled__ZIxsO","mark":"CloseButton_mark__2pwRm","small":"CloseButton_small__Dzljk"};